<template>
  <div>
    <section class="section-blog-header">
      <div class="header-blog">
        <div class="header__text-box">
          <h1 class="heading-primary">
            <span class="heading-primary--main">Your Profile</span>
          </h1>
        </div>
      </div>
    </section>
    <div v-if="this.$store.getters.userinformation">
      <b-card no-body>
        <b-tabs
          active-nav-item-class="font-weight-bold text-uppercase text-danger"
          active-tab-class="font-weight-bold"
          content-class="mt-3"
          card
        >
          <b-tab title="Profile">
            <h3> Profile Settings </h3>
            <hr>

            <form>
              <div class="form-group">
                <label for="displayName">Display Name</label>
                <input
                  id="displayName"
                  v-model="displayName"
                  type="text"
                  class="form-control"
                >
              </div>
              <div class="form-group">
                <label for="exampleFormControlTextarea1">About Yourself</label>
                <textarea
                  id="exampleFormControlTextarea1"
                  v-model="about"
                  class="form-control"
                  rows="3"
                />
              </div>
            </form>
            <span
              v-if="feedback"
              class="tag tag-danger"
            >  <hr>{{ feedback }}     <hr> </span>

            <br>
            <br>

            <h3> Notification Settings </h3>
            <hr>
            <br>
            <div class="form-group">
              <label for="sel1">Email me blog updates
              </label>
              <select
                v-model="notificiationBlogSelected"
                name="sel1"
                class="form-control"
              >
                <option
                  v-for="(notificiationBlog, value) in notificiationBlogOptions"
                  :key="value"
                  :value="notificiationBlog.value"
                >
                  {{ notificiationBlog.text }}
                </option>
              </select>
            </div>
            <br>
            <br>
            <label for="sel1">Email me site updates
            </label>
            <select
              v-model="notificiationSiteSelected"
              name="sel2"
              class="form-control"
            >
              <option
                v-for="(notificiationSite, value) in notificiationSiteOptions"
                :key="value"
                :value="notificiationSite.value"
              >
                {{ notificiationSite.text }}
              </option>
            </select>
            <button
              type="submit"
              style="margin-top: 10px;"
              class="btn btn-primary float-right"
              @click.prevent="updateUserDetails"
            >
              Update
            </button>
            <br>
            <br>
          </b-tab>
          <b-tab title="Account">
            <h3> Account Settings for {{ this.$store.getters.userinformation.email }}</h3>
            <hr>
            <br>
            <div class="container bootstrap snippet">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-md-offset-2">
                  <div class="panel panel-info">
                    <div class="panel-heading" />
                    <div class="panel-body">
                      <div class="row">
                        <div
                          style="margin-top:80px;"
                          class="col-xs-6 col-sm-6 col-md-6 separator social-login-box"
                        >
                          <br>
                          <h3 class="panel-title">
                            <span class="glyphicon glyphicon-th" />
                            Change password
                          </h3>
                        </div>
                        <div
                          style="margin-top:80px;"
                          class="col-xs-6 col-sm-6 col-md-6 login-box"
                        >
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-addon">
                                <span
                                  class="fa fa-lock"
                                  style="padding-top: 10px; padding-right:10px;"
                                />
                              </div>
                              <input
                                v-model="currentPassword"
                                class="form-control"
                                type="password"
                                placeholder="Current Password"
                              >
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-addon">
                                <span
                                  class="fa fa-sign-in"
                                  style="padding-top: 10px; padding-right:10px;"
                                />
                              </div>
                              <input
                                v-model="newPassword"
                                class="form-control"
                                type="password"
                                placeholder="New Password"
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="panel-footer">
                      <div class="row">
                        <div class="col-xs-6 col-sm-6 col-md-6">
                          <p v-if="feedbackAccount.length">
                            <b>Please correct the following error(s):</b>
                            <ul>
                              <li
                                v-for="(error, value) in feedbackAccount"
                                :key="value"
                              >
                                {{ error }}
                              </li>
                            </ul>
                          </p>
                        </div>
                        <div class="col-xs-6 col-sm-6 col-md-6">
                          <button
                            class="btn  float-right icon-btn-save btn-success"
                            type="submit"
                            @click.prevent="validatePasswordChange"
                          >
                            <span class="btn-save-label"><i class="fa fa-floppy-o" /></span> Update Password
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container bootstrap snippet">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-md-offset-2">
                  <div class="panel panel-info">
                    <div class="panel-heading" />
                    <div class="panel-body">
                      <div class="row">
                        <div
                          style="margin-top:80px;"
                          class="col-xs-6 col-sm-6 col-md-6 separator social-login-box"
                        >
                          <br>
                          <h3 class="panel-title">
                            <span class="glyphicon glyphicon-th" />
                            Update Email
                            <h6>This will cause you to be logged out, and you will need to reverify your account</h6>
                          </h3>
                        </div>
                        <div
                          style="margin-top:80px;"
                          class="col-xs-6 col-sm-6 col-md-6 login-box"
                        >
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-addon">
                                <span
                                  class="fa fa-sign-in"
                                  style="padding-top: 10px; padding-right:10px;"
                                />
                              </div>
                              <input
                                v-model="newEmail"
                                class="form-control"
                                type="email"
                                placeholder="New Email Address"
                              >
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-addon">
                                <span
                                  class="fa fa-lock"
                                  style="padding-top: 10px; padding-right:10px;"
                                />
                              </div>
                              <input
                                v-model="currentPassword"
                                class="form-control"
                                type="password"
                                placeholder="Current Password"
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="panel-footer">
                      <div class="row">
                        <div class="col-xs-6 col-sm-6 col-md-6">
                          <p v-if="feedbackEmail.length">
                            <b>Please correct the following error(s):</b>
                            <ul>
                              <li
                                v-for="(error, value) in feedbackEmail"
                                :key="value"
                              >
                                {{ error }}
                              </li>
                            </ul>
                          </p>
                        </div>
                        <div class="col-xs-6 col-sm-6 col-md-6">
                          <button
                            class="btn  float-right icon-btn-save btn-success"
                            type="submit"
                            @click.prevent="validateEmailChange"
                          >
                            <span class="btn-save-label"><i class="fa fa-floppy-o" /></span> Update Email
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container bootstrap snippet">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-md-offset-2">
                  <div class="panel panel-info">
                    <div class="panel-heading" />
                    <div class="panel-body">
                      <div class="row">
                        <div
                          style="margin-top:80px;"
                          class="col-xs-6 col-sm-6 col-md-6 separator social-login-box"
                        >
                          <br>
                          <h3 class="panel-title">
                            <span class="glyphicon glyphicon-th" />
                            Delete Account
                          </h3>
                          <h5>This cannot be undone</h5>
                        </div>
                        <div
                          style="margin-top:100px;"
                          class="col-xs-6 col-sm-6 col-md-6 login-box"
                        >
                          <button
                            type="submit"
                            class="btn btn-danger"
                          >
                            Delete Account
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {

  name: 'ViewProfile',
  data () {
    return {
      about: this.$store.getters.userinformation.about,
      displayName: this.$store.getters.userinformation.displayName,
      useruid: this.$store.getters.userinformation.uid,
      email: this.$store.getters.userinformation.email,
      currentPassword: null,
      newPassword: null,
      newEmail: null,
      currentPasswordEmail: null,
      selecteduser: null,
      showModalResetPassword: false,
      feedbackAccount: [],
      feedbackEmail: [],
      feedback: null,
      emailreg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      notificiationBlogSelected: this.$store.getters.userinformation.notification_level_blogs,
      notificiationBlogOptions: [
        { text: 'For Every Blog Post', value: 0 },
        { text: 'Monthly', value: 1 },
        { text: 'Never', value: 2 }
      ],
      notificiationSiteSelected: this.$store.getters.userinformation.notification_level_site,
      notificiationSiteOptions: [
        { text: 'Yes', value: 0 },
        { text: 'No', value: 1 }
      ]
    }
  },
  mounted () {
    console.log(this.$store.getters.userinformation)
  },
  methods: {
    updateEmail () {
    // update email
    // resend verification email
    },
    validateEmailChange () {
      this.feedbackEmail = []
      console.log('here we go')
      if (!this.newEmail) {
        this.feedbackEmail.push('You need to supply a new email')
      }
      if (!this.validateEmail(this.newEmail)) {
        this.feedbackEmail.push('You need to supply a valid email')
      }
      if (!this.currentPassword) {
        this.feedbackEmail.push('You need to supply your current password')
      }
      if (!this.feedbackEmail.length) {
        console.log('Lets update the use email')
        console.log(this.email, this.newEmail, this.currentPassword)
        firebase.auth()
          .signInWithEmailAndPassword(this.email, this.currentPassword)
          .then((userCredential) => {
            userCredential.user.updateEmail(this.newEmail)
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    validateEmail (email) {
      return this.emailreg.test(email)
    },
    validatePasswordChange () {
      console.log(this.newPassword, this.currentPassword)
      this.feedbackAccount = []

      if (!this.currentPassword) {
        this.feedbackAccount.push('Current Password Required')
      }

      if (!this.newPassword) {
        this.feedbackAccount.push('A new password is required to update your account')
      }

      if (this.newPassword.length < 7) {
        this.feedbackAccount.push('Your password must be greater than 7 characters')
      }

      if (!this.validatePasswordComplexity(this.newPassword)) {
        this.feedbackAccount.push('Please provide a strong password')
      }
      if (!this.feedbackAccount.length) {
        console.log('lets change the password', this.email, this.displayName)
        firebase.auth()
          .signInWithEmailAndPassword(this.email, this.currentPassword)
          .then((user) => {
            firebase.auth().currentUser.updatePassword(this.newPassword).then(() => {
              this.feedbackAccount.push('Password has been updated, an email has been sent to you notifying you of this change!')
              const emailUserPasswordUpdate = firebase.functions().httpsCallable('UserPasswordChangedEmail')
              emailUserPasswordUpdate({ email: this.email, displayName: this.displayName }).then((result) => {
                firebase.auth().signOut()
                this.$router.push('Login')
              })
            }).catch((err) => {
              console.log(err)
            })
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    validatePasswordComplexity (password) {
      const re = /^^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/
      return re.test(password)
    },
    updateUserDetails () {
      this.feedback = null
      if (!this.about || !this.displayName) {
        console.log('Error')
        this.feedback = 'Please ensure that you have filled in all the required fields'
      } else {
        db.collection('userDetails').where('user_id', '==', this.useruid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const payload = { about: this.about, displayName: this.displayName, notification_level_blogs: this.notificiationBlogSelected, notification_level_site: this.notificiationSiteSelected }
              db.collection('userDetails').doc(doc.id).update(payload)
              this.$store.dispatch('setUserProfile', payload)
              this.$toasted.show('Details have been updated', {
                position: 'top-center',
                action: {
                  text: 'Okay',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                }
              })
            })
          })
          .then(console.log('updated'))
      }
    }
  }
}
</script>

<style>

body {
  overflow-y: scroll !important;
}
  section {
    padding: 60px 0;
}

section .section-title {
    text-align: center;
    color: #007b5e;
    margin-bottom: 50px;
    text-transform: uppercase;
}
#tabs{
  background: #007b5e;
    color: #eee;
}
#tabs h6.section-title{
    color: #eee;
}

#tabs .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #f3f3f3;
    background-color: transparent;
    border-color: transparent transparent #f3f3f3;
    border-bottom: 4px solid !important;
    font-size: 20px;
    font-weight: bold;
}
#tabs .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
    color: #eee;
    font-size: 20px;
}
</style>
